import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=fc3bf21e&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=fc3bf21e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3bf21e",
  null
  
)

export default component.exports